import { useState } from "react";
import queryString from "query-string";
import { styled } from "styled-components";
import { warn } from "rtUtils/logger";
import { useCreateRendererApi } from "renderer/hooks/useCreateRendererApi";
import { BaseViewer } from "../Viewer";
import { ArStartButton } from "../ArButton";
import { VIEWER_MODES } from "../../consts";
import { ModelProductConfigFromQuery } from "../ModelProductConfig";
import { getIsArSupported, getSceneViewerIntentUrl, parseArParams } from "../../utils/arUtils";
import ANALYTICS_EVENTS from "../../analyticsEvents";

const qs = queryString.parse(location.search);

const Wrapper = styled.main`
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const UnsupportedText = styled.div`
    font-size: 18px;
    color: #420303;
`;

const QrBottom = styled.div`
    height: 60px;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 10px 0;
    box-shadow: 0 -10px 20px -6px rgb(100, 96, 100, 0.8);
`;

const QrModeViewer = () => {
	const [renderingApi, setRenderingApi] = useState(null);
	const modelUrl = qs.model;
	const fallback = qs.fallback;
	const debug = qs.debug;
	const cloudName = qs.cloudName;
	const params = parseArParams(qs.params);
	const { onModelReady, onRenderingReady } = useCreateRendererApi(modelUrl, setRenderingApi);

	//TODO: accept valid url from env-var - support staging!!
	const isValid = modelUrl && modelUrl.startsWith("https://");
		// TODO: not relevent for cutomres with custom CNAME
		// && (modelUrl.startsWith("https://res.cloudinary.com") ||
		// 	modelUrl.startsWith("https://dimensions-art.cloudinary.net"));

	if (!isValid) {
		warn("received invalid model url: " + modelUrl);
	}

	const isArSupported = getIsArSupported(true);

	return (
		<Wrapper>
			{isValid ?
				<>
					<QrBottom>
						{
							isArSupported ?
								<ArStartButton
									modelUrl={modelUrl}
									fallbackUrl={fallback}
									renderingApi={renderingApi}
									params={params}
									cloudName={cloudName}
								/> :
								<UnsupportedText>AR isn't available on this device</UnsupportedText>
						}
					</QrBottom>
					{debug === "true" && <span>{getSceneViewerIntentUrl({ src: modelUrl, params, cloudName })}</span>}
					<BaseViewer
						mode={VIEWER_MODES.QR}
						modelUrl={modelUrl}
						ProductConfigApplier={ModelProductConfigFromQuery}
						onModelReady={onModelReady}
						renderingApi={renderingApi}
						onRenderingReady={onRenderingReady}
						ANALYTICS_EVENTS={{}}
					/>
				</> :
				<h2>Incorrect Information provided</h2>}
		</Wrapper>
	);
};

export default QrModeViewer;
